const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15 4a.746.746 0 00-.627.036.73.73 0 00-.372.504l-4 14a.758.758 0 00.509.93h.21a.738.738 0 00.72-.54l4-14a.758.758 0 00-.439-.93zM9.32 5.26a.758.758 0 00-1.06-.08l-7 6a.763.763 0 00-.194.256.758.758 0 00.194.884l7 6a.758.758 0 101-1.14L2.9 11.75l6.34-5.43a.758.758 0 00.08-1.06zm14.92 5.92l-7-6a.758.758 0 10-1 1.14l6.36 5.43-6.34 5.43a.752.752 0 00-.256.521.76.76 0 001.256.619l7-6a.75.75 0 000-1.14h-.02z"
});

const SvgEmbed = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmbed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/embed.2d68e6cd.svg";
export { ForwardRef as ReactComponent };